import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import { StoreProvider, ErrorFlash, Label } from '../../components';
import { createCategory } from '../../mutations';

export class CategoryNewView extends Component {
  state = {
    name: '',
    errors: null,
  };

  handleName = (event) => {
    this.setState({ name: event.target.value });
  };

  notify = () =>
    toast.success('Category Successfully Created!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

  handleSubmit = (event) => {
    event.preventDefault();

    const { lists, relay } = this.props;
    createCategory(relay.environment, this.state.name, lists.id, {
      onCompleted: this.handleSubmitSuccess,
      onError: this.handleSubmitFailure,
    });
  };

  handleSubmitSuccess = (response) => {
    let { errors } = response.createCategory;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/categories');
      this.notify();
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <div className="category-new">
        <form className="category-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Add Category</h2>
            <div className="form-header-actions">
              <input
                id="saveCategory"
                className="category-new-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="name-field">
              <Label attr="name" text="Name" errors={errors} />
              <input
                type="name"
                id="name"
                value={this.state.name}
                onChange={this.handleName}
                required
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = withRouter(
  createFragmentContainer(CategoryNewView, {
    lists: graphql`
      fragment CategoryNew_lists on Lists {
        id
      }
    `,
  })
);

export default class CategoryNew extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query CategoryNewQuery {
            lists {
              ...CategoryNew_lists
            }
          }
        `}
      />
    );
  }
}
